import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import moment from 'moment';

const TransaferenciaRow = (props) => {
    return (
        <li className="list-group-item list-group-item-action flex-column align-items-start" style={{ "backgroundColor": "#EFF8FB" }}>
            <div className="row">
                <div className="col-12 col-md-9">
                    <div className="d-flex w-100 justify-content-between">
                        <span>Transferência de <b>{props.conta_origem}</b> para <b>{props.conta_destino}</b></span>
                        <small>{parseFloat(props.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                    </div>
                    <small>{moment(props.data_pagamento).format('DD/MM/YYYY')}</small>
                </div>
                <div className="col-2 text-right d-none d-md-block">
                    <small>{props.acumulado.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</small>
                </div>
                <div className="col col-md-1">
                    <Link to={`/transferencia/${props.transferencia_id}`}>
                        <i className="far fa-edit" style={{ cursor: "pointer" }} />
                    </Link>
                    {" | "}
                    <i className="far fa-trash-alt" style={{ cursor: "pointer" }}
                        onClick={() => props.handleDelete(props.transferencia_id)} />
                </div>
            </div>
        </li>
    );
};

TransaferenciaRow.propTypes = {
    tipo: PropTypes.string.isRequired,
    status: PropTypes.bool.isRequired,
    descricao: PropTypes.string.isRequired,
    conta_origem: PropTypes.string.isRequired,
    conta_destino: PropTypes.string.isRequired,
    valor: PropTypes.string.isRequired,
    acumulado: PropTypes.number.isRequired,
    data_pagamento: PropTypes.string.isRequired,
    id: PropTypes.number.isRequired,
    transferencia_id: PropTypes.number.isRequired,
    handleDelete: PropTypes.func.isRequired,
};

export default TransaferenciaRow;


// WEBPACK FOOTER //
// ./src/components/relatorios/TransferenciaRow.js